import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { CheckCircle2, Star } from 'lucide-react';
export function PricingSection() {
  return <section className="py-20 px-4" id="pricing" data-id="element-201">
      <div className="max-w-5xl mx-auto" data-id="element-202">
        <div className="text-center mb-12" data-id="element-203">
          <h2 className="text-3xl font-heading font-bold text-white mb-6" data-id="element-204">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <CountdownTimer className="mb-6" data-id="element-205" />
          <div className="inline-flex items-center gap-2 bg-danger/10 text-danger px-4 py-2 rounded-lg font-medium mb-6" data-id="element-206">
            <span data-id="element-207">⚠️</span> Después sube $8.000 ARS. No vuelve.
          </div>

          <div className="max-w-md mx-auto bg-surface border border-border rounded-full p-1 relative overflow-hidden" data-id="element-208">
            <div className="absolute top-0 left-0 h-full bg-danger/20 w-[68%] rounded-full" data-id="element-209"></div>
            <div className="relative z-10 text-sm font-medium py-1 px-4 flex justify-between items-center" data-id="element-210">
              <span className="text-white" data-id="element-211">
                🔴 Cupos al precio de lanzamiento
              </span>
              <span className="text-danger font-bold" data-id="element-212">68% tomados</span>
            </div>
          </div>
        </div>

        <div className="text-center mb-10" data-id="element-213">
          <h2 className="text-4xl font-heading font-bold text-white" data-id="element-214">
            ELEGÍ TU MEGAPACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-215">
          {/* Standard Tier */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-surface border border-border rounded-3xl p-8 flex flex-col" data-id="element-216">
            <div className="text-4xl mb-4" data-id="element-217">📘</div>
            <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-218">
              MEGAPACK SCOOTER ELÉCTRICO
            </h3>
            <p className="text-brand font-medium mb-6" data-id="element-219">3 eBooks + 3 Bonos</p>

            <div className="bg-background rounded-xl p-4 mb-8" data-id="element-220">
              <p className="text-sm text-muted" data-id="element-221">
                <span className="font-bold text-white" data-id="element-222">Ideal para:</span>{' '}
                usuarios que quieren entender, mantener y reparar su scooter
              </p>
            </div>

            <div className="mb-8 flex-grow" data-id="element-223">
              <div className="flex items-center gap-3 text-danger line-through text-xl font-bold mb-1" data-id="element-224">
                $45.000
              </div>
              <div className="text-5xl font-heading font-bold text-white mb-2" data-id="element-225">
                $19.990{' '}
                <span className="text-xl text-muted font-body" data-id="element-226">ARS</span>
              </div>
            </div>

            <CtaButton variant="brand" className="w-full" data-id="element-227">
              → QUIERO MI MEGAPACK
            </CtaButton>
          </motion.div>

          {/* Pro Tier */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-surface border-2 border-accent rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(255,171,0,0.15)]" data-id="element-228">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-black font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-229">
              <Star size={14} className="fill-black" data-id="element-230" /> RECOMENDADO
            </div>

            <div className="text-4xl mb-4" data-id="element-231">🏆</div>
            <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-232">
              MEGAPACK + KIT SISTEMA DE GESTIÓN PRO ⭐
            </h3>
            <p className="text-accent font-medium mb-6" data-id="element-233">
              3 eBooks + 3 Bonos + Kit Pro completo
            </p>

            <div className="bg-background rounded-xl p-4 mb-8 border border-accent/20" data-id="element-234">
              <p className="text-sm text-muted" data-id="element-235">
                <span className="font-bold text-white" data-id="element-236">Ideal para:</span>{' '}
                usuarios con scooters de alta potencia, flotas o uso intensivo
                diario
              </p>
            </div>

            <div className="mb-8 flex-grow" data-id="element-237">
              <div className="flex items-center gap-3 text-danger line-through text-xl font-bold mb-1" data-id="element-238">
                $65.000
              </div>
              <div className="text-5xl font-heading font-bold text-white mb-2" data-id="element-239">
                $27.990{' '}
                <span className="text-xl text-muted font-body" data-id="element-240">ARS</span>
              </div>
            </div>

            <CtaButton variant="accent" className="w-full" data-id="element-241">
              → QUIERO EL MEGAPACK + KIT PRO
            </CtaButton>
          </motion.div>
        </div>
      </div>
    </section>;
}